import type { Platform, ShareContent } from '../types';
import { buildQueryString } from '../utils/url';
import { PlatformRegistry } from './registry';

export const email: Platform = {
  id: 'email',
  name: 'Email',
  iconIndex: PlatformRegistry.email.index,
  color: PlatformRegistry.email.color,
  buildUrl: (content: ShareContent): string => {
    const body = [
      content.title,
      content.description,
      content.url,
    ].filter(Boolean).join('\n\n');
    
    const params = buildQueryString({
      subject: content.title,
      body,
    });
    
    return `mailto:?${params}`;
  },
};

